import React, { useState } from 'react';
import { Trash2, ArrowUp, ArrowDown, Plus, Image as ImageIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { useHeroImages } from '../../hooks/useHeroImages';
export function HeroImagesSection() {
  const {
    images,
    addImage,
    deleteImage,
    moveImage,
    canAdd
  } = useHeroImages();
  const [newImageUrl, setNewImageUrl] = useState('');
  const [isAdding, setIsAdding] = useState(false);
  const handleAdd = (e: React.FormEvent) => {
    e.preventDefault();
    if (newImageUrl.trim()) {
      addImage(newImageUrl.trim());
      setNewImageUrl('');
      setIsAdding(false);
    }
  };
  const handleDelete = (id: number) => {
    if (window.confirm('¿Estás seguro de eliminar esta imagen del carrusel?')) {
      deleteImage(id);
    }
  };
  return <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 mb-8" data-id="element-32">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4" data-id="element-33">
        <div data-id="element-34">
          <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2" data-id="element-35">
            <ImageIcon className="h-5 w-5 text-blue-600" data-id="element-36" />
            Imágenes del Hero
          </h2>
          <p className="text-sm text-gray-500 mt-1" data-id="element-37">
            Gestiona las imágenes de fondo del inicio (máximo 4). Se rotarán
            automáticamente cada 6 segundos.
          </p>
        </div>
        <div className="text-sm font-medium bg-blue-50 text-blue-700 px-3 py-1 rounded-full border border-blue-100" data-id="element-38">
          {images.length} / 4 imágenes
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6" data-id="element-39">
        {images.map((image, index) => <div key={image.id} className="group relative bg-gray-50 rounded-lg border border-gray-200 overflow-hidden hover:shadow-md transition-all" data-id="element-40">
            <div className="aspect-video w-full relative overflow-hidden bg-gray-100" data-id="element-41">
              <img src={image.url} alt={`Hero background ${index + 1}`} className="w-full h-full object-cover" data-id="element-42" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" data-id="element-43" />

              {/* Overlay controls */}
              <div className="absolute inset-0 flex items-center justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity bg-black/20 backdrop-blur-[1px]" data-id="element-44">
                <button onClick={() => moveImage(image.id, 'up')} disabled={index === 0} className="p-1.5 bg-white text-gray-700 hover:text-blue-600 rounded shadow-sm disabled:opacity-50 disabled:cursor-not-allowed" title="Mover al inicio" data-id="element-45">
                  <ArrowUp className="h-3 w-3" data-id="element-46" />
                </button>
                <button onClick={() => moveImage(image.id, 'down')} disabled={index === images.length - 1} className="p-1.5 bg-white text-gray-700 hover:text-blue-600 rounded shadow-sm disabled:opacity-50 disabled:cursor-not-allowed" title="Mover al final" data-id="element-47">
                  <ArrowDown className="h-3 w-3" data-id="element-48" />
                </button>
                <button onClick={() => handleDelete(image.id)} className="p-1.5 bg-white text-red-500 hover:text-red-700 rounded shadow-sm" title="Eliminar" data-id="element-49">
                  <Trash2 className="h-3 w-3" data-id="element-50" />
                </button>
              </div>
            </div>

            <div className="p-2 bg-white border-t border-gray-100" data-id="element-51">
              <p className="text-[10px] font-medium text-gray-500 uppercase tracking-wider mb-0.5" data-id="element-52">
                Imagen {index + 1}
              </p>
            </div>
          </div>)}
      </div>

      {canAdd ? isAdding ? <form onSubmit={handleAdd} className="bg-gray-50 p-4 rounded-lg border border-gray-200 animate-in fade-in slide-in-from-top-2 duration-200" data-id="element-53">
            <div className="flex flex-col sm:flex-row gap-3 items-end" data-id="element-54">
              <div className="flex-1 w-full" data-id="element-55">
                <Input label="URL de la imagen" value={newImageUrl} onChange={e => setNewImageUrl(e.target.value)} placeholder="https://ejemplo.com/imagen.jpg" required data-id="element-56" />
              </div>
              <div className="flex gap-2 w-full sm:w-auto" data-id="element-57">
                <Button type="submit" className="w-full sm:w-auto" data-id="element-58">
                  Guardar
                </Button>
                <Button type="button" variant="outline" onClick={() => {
            setIsAdding(false);
            setNewImageUrl('');
          }} className="w-full sm:w-auto" data-id="element-59">
                  Cancelar
                </Button>
              </div>
            </div>
          </form> : <Button onClick={() => setIsAdding(true)} variant="outline" className="w-full border-dashed border-2 hover:border-blue-500 hover:bg-blue-50" leftIcon={<Plus className="h-4 w-4" data-id="element-61" />} data-id="element-60">
            Agregar nueva imagen
          </Button> : <div className="text-center p-4 bg-gray-50 rounded-lg border border-gray-200 text-sm text-gray-500" data-id="element-62">
          Has alcanzado el límite máximo de 4 imágenes. Elimina una para agregar
          otra.
        </div>}
    </div>;
}